
import './app.less';
import {useEffect, useMemo, useState} from "react";
import Introduction from '../../components/digitalWalletFAQ/Introduction'
import Subscription from "../../components/digitalWalletFAQ/Subscription";
import {useTranslation} from "react-i18next";
import '../../i18n'
import i18n from "i18next";
import {getQueryValue} from "../../util";
function App() {
	const { t } = useTranslation()
	const [language , setLanguage] = useState('en')
	const [forceUpdate, setForceUpdate] = useState({});
	const [tabs, setTabs] = useState([]);
	useEffect(() => {
		const language = getQueryValue('language');
		if (language === 'en') {
			i18n.changeLanguage('en');
			setLanguage('en');
		} else if (language === 'zh') {
			i18n.changeLanguage('zh');
			setLanguage('zh');
		}else {
			i18n.changeLanguage('zh');
			setLanguage('zh');
		}
		document.title=t('digitalMetaTitle')
		setForceUpdate({}); // 触发强制更新
	}, []);

	useEffect(() => {
		// 重新构建 tabs 数组
		const newTabs = [
			{ id: 1, title: t('tabTitle1'), content: <Introduction /> },
			{ id: 2, title: t('tabTitle2'), content: <Subscription /> },
		];
		setTabs(newTabs);
	}, [language, t, forceUpdate]);

	const [activeTab, setActiveTab] = useState(1);
	const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content;
	const handleTabClick = (tabId) => {
		setActiveTab(tabId);
	};
	const setDescOrShareStr = useMemo(() => {
		return () => {
			let shareStr = {
				title: t('digitalMetaTitle'),
				desc: t('digitalMetaDescription'),
				icon: 'https://chainpal.tongfudun.com/favicon.ico',
			}
			console.log(shareStr)
			return window.btoa(
				unescape(window.encodeURIComponent(JSON.stringify(shareStr)))
			)
		}
	}, [t])
	// 获取信息

	useEffect(() => {
			let shareStr = setDescOrShareStr()
			let reg = new RegExp('chainmeetShare=[^&]*', 'gi')
			let url =
				window.location.search.indexOf('chainmeetShare') > -1
					? window.location.search.replace(reg, `chainmeetShare=${shareStr}`)
					: `${window.location.search}${!window.location.search ? '?' : '&'
					}&chainmeetShare=${shareStr}`

			window.history.replaceState(null, null, url)
	}, [setDescOrShareStr]);
	return (
		<div className="App">
			{/*<div className="tabs">*/}
			{/*	{tabs.map((tab) => (*/}
			{/*		<div*/}
			{/*			key={tab.id}*/}
			{/*			className={activeTab === tab.id ? 'tab active' : 'tab'}*/}
			{/*			onClick={() => handleTabClick(tab.id)}*/}
			{/*		>*/}
			{/*			{tab.title}*/}
			{/*		</div>*/}
			{/*	))}*/}
			{/*</div>*/}
			{/*<div className="tab-content">*/}
			{/*	{activeTabContent && activeTabContent}*/}
			{/*</div>*/}
			<h2>{t('digitalMetaTitle')}</h2>
			<Introduction />
			<Subscription />
		</div>
	);
}

export default App;
